<template>
    <div>
        <div class="tip">
            a) Antecedentes: (Información sobre la última compra vigente o próxima a vencer)
        </div>
        <el-table
                :data="[requestForm]"
                style="width: 100%">

            <el-table-column
                    prop="date"
                    label="Tipo"
                    min-width="150">

                <template slot-scope="scope">

                    <el-select
                            :disabled="onlyRead== true ? true: false"
                            style="width:100%"
                            v-model="scope.row.old_provider_cat_agreement_type_id"
                            filterable
                            clearable
                            placeholder="Seleccionar">
                        <el-option
                                v-for="(item,key) in catalogs.catAgreementType"
                                :key="key"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>

            <el-table-column
                    prop="date"
                    label="Proveedor"
                    min-width="150">

                <template slot-scope="scope">

                    <el-input v-model="scope.row.old_provider_name"
                              :disabled="onlyRead== true ? true: false"
                              placeholder=""/>

                </template>
            </el-table-column>

            <el-table-column label="Periodo">
                <el-table-column
                        prop="periodStart"
                        label="Inicio"
                        min-width="120">

                    <template slot-scope="scope">
                        <el-date-picker
                                :disabled="onlyRead== true ? true: false"
                                :editable="false"
                                v-model="scope.row.old_provider_period_start"
                                type="date"
                                placeholder="Selecciona una fecha"
                                style="width: 100%"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </template>


                </el-table-column>
                <el-table-column
                        prop="periodEnd"
                        label="Fin"
                        min-width="120">

                    <template slot-scope="scope">
                        <el-date-picker
                                :disabled="scope.row.old_provider_cat_agreement_type_id == 2 || onlyRead== true ? true: false"
                                :editable="false"
                                v-model="scope.row.old_provider_period_end"
                                type="date"
                                placeholder="Selecciona una fecha"
                                style="width: 100%"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </template>
                </el-table-column>
            </el-table-column>


            <el-table-column
                    prop="monthlyCost"
                    label="Costo Mensual"
                    min-width="210">
                <template slot-scope="scope">



                    <vue-numeric currency="$"
                                 :disabled="onlyRead== true ? true: false"
                                 class="el-input__inner"
                                 separator=","
                                 v-model="scope.row.old_provider_monthly_cost"
                                 :max="1000000000"
                                 :precision="2"
                    ></vue-numeric>

                </template>
            </el-table-column>


            <el-table-column label="Folio de autorización (Plurianual SHCP)" min-width="250">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.folioSHCP"
                              :disabled="scope.row.old_provider_cat_agreement_type_id == 2 ||onlyRead== true ? true: false"
                              placeholder="">
                    </el-input>
                </template>
            </el-table-column>

        </el-table>



        <el-form-item
                label="1. Justificación"
                prop="explanation"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
            <el-input v-model="requestForm.explanation"
                      type="textarea"
                      :disabled="true"
                      :autosize="{ minRows: 4, maxRows: 8}"
                      placeholder="Justificación">
            </el-input>
        </el-form-item>


        <Label :tooltipDisabled="false"
               labelTooltip=""
               title="3. Justificación de la selección del Proveedor"
               body=""></Label>

        <el-form-item
                label="Nombre del proveedor:">

            <el-select
                    style="width:100%"
                    :disabled="onlyRead== true ? true: false"
                    v-model="providerActive"
                    @change="selectedProvider(providerActive)"
                    filterable
                    clearable
                    placeholder="Seleccionar">
                <el-option
                        v-for="(item,key) in filterId(requestForm.providers)"
                        :key="key"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>


        </el-form-item>


        <el-form-item
                label="Motivos de la selección del proveedor:"
                prop="provider_selected.selectionReasons"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

            <el-input v-model="requestForm.provider_selected.selectionReasons"
                      type="textarea"
                      :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                      :autosize="{ minRows: 8, maxRows: 8}"
                      placeholder="Motivos de la selección del proveedor">
            </el-input>
        </el-form-item>

        <el-form-item
                label="Tipo de moneda:"
                prop="provider_selected.paymentCurrency"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

            <el-select
                    style="width:100%"
                    v-model="requestForm.provider_selected.paymentCurrency"
                    filterable
                    clearable
                    :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                    placeholder="Seleccionar">
                <el-option
                        v-for="(item,key) in catalogs.catCurrencies"
                        :key="key"
                        :label="item.name+' '+item.code"
                        :value="item.id">
                </el-option>
            </el-select>

        </el-form-item>


        <table border="1" width="100%">
            <thead>
            <tr>
                <th align="center" style="background: #a1ccef; text-align: center">
                    Conceptos
                </th>
                <th align="center" style=" background: #a1ccef;text-align: center">
                    Montos
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    Precio Mensual
                </td>
                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.monthlyCostWithTaxes"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">


                        <vue-numeric currency="$"
                                     :disabled="true"
                                     class="el-input__inner"
                                     style="border:none !important;"
                                     separator=","
                                     v-model="requestForm.provider_selected.monthlyCostWithTaxes"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>


                    </el-form-item>
                </td>
            </tr>

            <tr>
                <td>
                    Precio total de bienes y servicios
                    (sin gastos adicionales)
                </td>
                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.totalPriceGoodsServices"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <vue-numeric currency="$"
                                     :disabled="onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.totalPriceGoodsServices"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>



                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>
                    Gastos de instalación
                </td>
                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.instalmentCosts"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">


                        <vue-numeric currency="$"
                                     :disabled="true"
                                     class="el-input__inner"
                                     style="border:none !important;"
                                     separator=","
                                     v-model="requestForm.provider_selected.instalmentCosts"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>

            <tr>
                <td>
                    Gastos de transporte
                </td>
                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.carrierExpenses"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <vue-numeric currency="$"
                                     :disabled="true"
                                     class="el-input__inner"
                                     style="border:none !important;"
                                     separator=","
                                     v-model="requestForm.provider_selected.carrierExpenses"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>
                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>
                    Otros gastos (describir)
                </td>
                <td align="center">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="">
                                <el-input v-model="requestForm.provider_selected.otherExpensesDescription"
                                          style="width: 100%; margin-top: 20px"
                                          :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                          type="textarea"
                                          :autosize="{ minRows: 4, maxRows: 8}"
                                          placeholder="Describa todos los gastos adicionales"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                    label=""
                                    prop="provider_selected.anotherExpenses"
                                    :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                                <vue-numeric currency="$"
                                             :disabled="true"
                                             class="el-input__inner"
                                             style="border:none !important;"
                                             separator=","
                                             v-model="requestForm.provider_selected.anotherExpenses"
                                             :max="1000000000"
                                             :precision="2"
                                ></vue-numeric>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </td>
            </tr>

            <tr>
                <td style="font-weight: bold;background: #c9c9c9c9">
                    SUBTOTAL DE GASTOS ADICIONALES
                </td>
                <td style="font-weight: bold;background: #c9c9c9c9; text-align: center">
                    ${{ subTotal(requestForm.provider_selected)}}
                </td>
            </tr>

            <tr>
                <td style="font-weight: bold;background: #c9c9c9c9">
                    TOTAL (suma del precio más los gastos adicionales)
                </td>
                <td style="font-weight: bold;background: #c9c9c9c9;text-align: center">
                    ${{total(requestForm.provider_selected)}}
                </td>
            </tr>
            </tbody>
        </table>

        <el-form-item
                label="Comparativa Costo-Beneficio (No aplica para servicios)">
            <el-input v-model="requestForm.provider_selected.comparativeCostBenefit"
                      type="textarea"
                      :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                      :autosize="{ minRows: 4, maxRows: 8}"
                      placeholder="Justificación">
            </el-input>
        </el-form-item>


        <Label :tooltipDisabled="false"
               labelTooltip=""
               title="Cuadro comparativo de adquisiciones vs arrendamiento"
               body=""></Label>



        <table border="1" width="100%">
            <thead>
            <tr>
                <th align="center" style="background: #ab0d48;text-align: center;color:#fff" class="border-red" colspan="2">
                    Adquisición
                </th>
                <th align="center" style="background: #a1ccef;text-align: center" colspan="5">
                    Costo del Arrendamiento Anual o Purianual
                </th>
            </tr>
            <tr>
                <th align="center" style="background: #ab0d48;color:#fff">

                </th>
                <th align="center" style="background: #ab0d48;text-align: center;color:#fff" class="border-red" >
                    Moneda local
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Mensual
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Meses
                </th>
                <th align="center" style="background: #a1ccef;text-align: center">
                    Anual
                </th>
            </tr>
            </thead>

            <tbody>
            <tr>
                <td style="">
                    Precio bienes
                </td>
                <td align="center" class="border-red">
                    <el-form-item
                            label=""
                            prop="provider_selected.acquisitionPriceGoods"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.acquisitionPriceGoods"
                                         :precision="2"
                                         :step="1"
                                         style="width: 100%; margin-top: 20px"
                                         :min="0"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder="Precio Mensual"></el-input-number>
                    </el-form-item>
                </td>
                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.leasingMonthlyPriceGoods"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.leasingMonthlyPriceGoods"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>


                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.leasingMonthsPriceGoods"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.leasingMonthsPriceGoods"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>

                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.leasingAnnualPriceGoods"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.leasingAnnualPriceGoods"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>


            </tr>

            <tr>
                <td>
                    Gastos de instalación (en caso de aplicar)
                </td>
                <td align="center" class="border-red">
                    <el-form-item
                            label="">

                        <el-input-number v-model="requestForm.provider_selected.acquisitionInstallationCosts"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>

                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.leasingMonthlyInstallationCosts"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.leasingMonthlyInstallationCosts"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>


                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.leasingMonthsInstallationCosts"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.leasingMonthsInstallationCosts"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>


                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.leasingAnnualInstallationCosts"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.leasingAnnualInstallationCosts"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>

            </tr>


            <tr>
                <td>
                    Gastos de transporte (en caso de aplicar)
                </td>
                <td align="center" class="border-red">
                    <el-form-item
                            label="">

                        <el-input-number v-model="requestForm.provider_selected.acquisitionTransportationExpenses"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>

                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.leasingMonthlyTransportationExpenses"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.leasingMonthlyTransportationExpenses"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>

                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.leasingMonthsTransportationExpenses"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.leasingMonthsTransportationExpenses"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>

                <td align="center">
                    <el-form-item
                            label=""
                            prop="provider_selected.leasingAnnualTransportationExpenses"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.leasingAnnualTransportationExpenses"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         style="width: 100%; margin-top: 20px"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>
                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>
                    Otros gastos (describir)
                </td>
                <td align="center" class="border-red">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item
                                    label="">

                                <el-input v-model="requestForm.provider_selected.acquisitionOtherExpensesDescription"
                                          type="textarea"
                                          :autosize="{ minRows: 4, maxRows: 8}"
                                          style="width: 100%; margin-top: 20px"
                                          :disabled="providerActive == '' ||  onlyRead== true ? true: false"

                                          placeholder="Describir gastos"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="">
                                <el-input-number size="small"
                                                 :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                                 :step="1"
                                                 :min="0"
                                                 :precision="2"
                                                 style="width: 100%; margin-top: 20px"
                                                 v-model="requestForm.provider_selected.acquisitionOtherExpenses"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </td>

                <td align="center">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item
                                    label=""
                                    prop="provider_selected.leasingMonthlyOtherExpenses"
                                    :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                                <el-input v-model="requestForm.provider_selected.leasingMonthlyOtherExpensesDescription"
                                          type="textarea"
                                          style="width: 100%; margin-top: 20px"
                                          :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                          :autosize="{ minRows: 4, maxRows: 8}"
                                          placeholder="Describir gastos"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="">
                                <el-input-number size="small"
                                                 :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                                 style="width: 100%; margin-top: 20px"
                                                 :step="1"
                                                 :min="0"
                                                 :precision="2"
                                                 v-model="requestForm.provider_selected.leasingMonthlyOtherExpenses"/>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </td>
                <td align="center">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item
                                    label=""
                                    prop="provider_selected.leasingMonthsOtherExpenses"
                                    :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                                <el-input v-model="requestForm.provider_selected.leasingMonthsOtherExpensesDescription"
                                          type="textarea"
                                          style="width: 100%; margin-top: 20px"
                                          :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                          :autosize="{ minRows: 4, maxRows: 8}"
                                          placeholder="Describir gastos"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="">
                                <el-input-number size="small"
                                                 :step="1"
                                                 :min="0"
                                                 :precision="2"
                                                 :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                                 style="width: 100%; margin-top: 20px"
                                                 v-model="requestForm.provider_selected.leasingMonthsOtherExpenses"/>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </td>


                <td align="center">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item
                                    label=""
                                    prop="provider_selected.leasingAnnualOtherExpenses"
                                    :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                                <el-input v-model="requestForm.provider_selected.leasingAnnualOtherExpensesDescription"
                                          type="textarea"
                                          style="width: 100%; margin-top: 20px"
                                          :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                          :autosize="{ minRows: 4, maxRows: 8}"
                                          placeholder="Describir gastos"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="">
                                <el-input-number size="small"
                                                 :step="1"
                                                 :min="0"
                                                 :precision="2"
                                                 :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                                 style="width: 100%; margin-top: 20px"
                                                 v-model="requestForm.provider_selected.leasingAnnualOtherExpenses"/>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </td>


            </tr>
            <tr>
                <td>
                    Totales
                </td>
                <td align="center" class="border-red">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="">
                                <div>
                                    ${{sumaX(requestForm.provider_selected,1)}}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </td>

                <td align="center">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="">
                                <div>
                                    ${{sumaX(requestForm.provider_selected,2)}}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </td>

                <td align="center">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="">
                                <div>
                                    ${{sumaX(requestForm.provider_selected,3)}}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </td>


                <td align="center">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="">
                                <div>
                                    ${{sumaX(requestForm.provider_selected,4)}}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </td>


            </tr>

            </tbody>

        </table>

        <div class="tip">
			<span style="font-size: 14pt ;color: red">
				Beneficio económico estimado ${{sumaX(requestForm.provider_selected,1)-sumaX(requestForm.provider_selected,4)}}
			</span>
        </div>

        <Label :tooltipDisabled="false"
               labelTooltip=""
               title="4. La justificación de la selección del proveedor que ofreció las mejores condiciones para el Estado Mexicano se motiva en los siguientes criterios (requisitar todos)"
               body=""></Label>

        <Economic :providerActive="providerActive"/>

        <div class="custom-label-body">
            5.
            <el-tag size="mini">
                {{ $store.state.user.office ? $store.state.user.office.type.name : '' }} de México en
                {{ $store.state.user.office ?  $store.state.user.office.location: '' }}
            </el-tag>
            manifiesta haber solicitado las cotizaciones en igualdad de condiciones para todos los proveedores
            convocados y cuenta con las cotizaciones originales recabadas en el expediente respectivo de la contratación
            para efectos de cualquier revisión posterior por parte de los órganos fiscalizadores.
            En caso de no contar con 3 cotizaciones, deberá adjuntar prueba documental que permita dar sustento a la
            investigación de mercado, así como justificar de conformidad con lo establecido en el numeral 6.3.2.1.9 de
            las POBALINES vigentes; o, en su caso, citar la circular para Representaciones de vida Difícil emitida por
            la DGSERH: <el-tag size="mini"> DSE-DG-01675 </el-tag>
        </div>


        <el-form-item
                label="6. Suficiencia presupuestaria"
                prop="provider_selected.cat_is_there_budget_id"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

            <el-select
                    style="width:100%"
                    v-model="requestForm.provider_selected.cat_is_there_budget_id"
                    filterable
                    clearable
                    :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                    placeholder="Seleccionar">
                <el-option
                        v-for="(item,key) in catalogs.catIsThereBudgets"
                        :key="key"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>

        </el-form-item>

        <table border="1" width="100%">
            <tr>
                <td align="center">
                    <el-form-item
                            label="Cantidad con la que se cuenta"
                            prop="provider_selected.quantityAvailable"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-input-number v-model="requestForm.provider_selected.quantityAvailable"
                                         :precision="2"
                                         :step="1"
                                         :min="0"
                                         :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                         placeholder=""></el-input-number>

                    </el-form-item>
                </td>
                <td align="center">
                    <el-form-item
                            label="Moneda"
                            prop="provider_selected.cat_currency_id"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

                        <el-select
                                style="width:100%"
                                v-model="requestForm.provider_selected.cat_currency_id"
                                filterable
                                clearable
                                :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                placeholder="Seleccionar">
                            <el-option
                                    v-for="(item,key) in catalogs.catCurrencies"
                                    :key="key"
                                    :label="item.name+' '+item.code"
                                    :value="item.id">
                            </el-option>
                        </el-select>

                    </el-form-item>
                </td>
            </tr>
        </table>




        <br/>
        <table border="1" width="100%">
            <thead>
            <tr>
                <th align="center" style="background: #a1ccef">
                    Mes
                </th>
                <th align="center" style="background: #a1ccef">
                    Monto
                </th>
            </tr>
            </thead>
            <tr>
                <td>Enero</td>
                <td align="center">
                    <el-form-item
                            label="">


                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.january"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>
            <tr>
                <td>Febrero</td>
                <td align="center">
                    <el-form-item
                            label="">

                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.february"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>


                    </el-form-item>
                </td>
            </tr>
            <tr>
                <td>Marzo</td>
                <td align="center">
                    <el-form-item
                            label="">

                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.march"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>Abril</td>
                <td align="center">
                    <el-form-item
                            label="">


                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.april"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>Mayo</td>
                <td align="center">
                    <el-form-item
                            label="">


                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.may"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>Junio</td>
                <td align="center">
                    <el-form-item
                            label="">


                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.june"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>Julio</td>
                <td align="center">
                    <el-form-item
                            label="">


                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.july"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>Agosto</td>
                <td align="center">
                    <el-form-item
                            label="">


                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.august"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>Septiembre</td>
                <td align="center">
                    <el-form-item
                            label="">


                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.september"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>Octubre</td>
                <td align="center">
                    <el-form-item
                            label="">

                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.october"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>


            <tr>
                <td>Noviembre</td>
                <td align="center">
                    <el-form-item
                            label="">
                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.november"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>

                    </el-form-item>
                </td>
            </tr>
            <tr>
                <td>Diciembre</td>
                <td align="center">

                    <el-form-item
                            label="">

                        <vue-numeric currency="$"
                                     :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                                     class="el-input__inner"
                                     separator=","
                                     v-model="requestForm.provider_selected.december"
                                     :max="1000000000"
                                     :precision="2"
                        ></vue-numeric>



                    </el-form-item>
                </td>
            </tr>
        </table>

        <el-form-item
                label="7. Indicar si es una contratación Plurianual"
                prop="provider_selected.cat_agreement_multiyear_id"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

            <el-select
                    style="width:100%"
                    v-model="requestForm.provider_selected.cat_agreement_multiyear_id"
                    filterable
                    clearable
                    :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                    placeholder="Seleccionar">
                <el-option
                        v-for="(item,key) in catalogs.catAgreementMultiyear"
                        :key="key"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>

        </el-form-item>

        <Payments :providerActive="providerActive"/>



        <el-form-item
                label="8. Justificación de que los términos y condiciones del contrato plurianual resultan más favorables respecto a contratar el arrendamiento o servicio cada ejercicio fiscal."
                prop="provider_selected.termsAndConditionsMultiyearJustification"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

            <el-input v-model="requestForm.provider_selected.termsAndConditionsMultiyearJustification"
                      type="textarea"
                      :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                      :autosize="{ minRows: 4, maxRows: 8}"
                      placeholder="• Indicar si las condiciones del mercado de ese país no ofrecen períodos menores a los solicitados para el arrendamiento de bienes o servicio requerido por la Representación.
• Indicar si se evitaría costos administrativos de renovación del contrato año con año (especificar un monto estimado)
• Indicar las consecuencias que se tendría o los gastos en los que podría incurrir la Representación, de no contratarse el arrendamiento o servicio de forma plurianual.">

            </el-input>
        </el-form-item>
        <br>
        <el-form-item
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

            <el-input v-model="requestForm.provider_selected.conclusion"
                      type="textarea"
                      :disabled="true"
                      :autosize="{ minRows: 4, maxRows: 8}">

            </el-input>
        </el-form-item>

        <showButtonPdf :type="3" label="Descargar Justificación 2019"/>

        <Docs :onlyRead="onlyRead" :sectionId="5">
            <div class="tip" style="padding: 35px;" slot="main">
                Suba su documento firmado de Justificación 2019
            </div>
        </Docs>


    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
    import Label from "@/components/views/acquisition/partials/Label";
    import Economic from "@/components/views/acquisition/partials/Economic";
    import Payments from "@/components/views/acquisition/partials/Payments";
    import showButtonPdf from '@/components/views/acquisition/partials/showButtonPdf'
    import Docs from '@/components/views/acquisition/partials/Docs'

    export default {

        components: {
            Docs,
            Label,
            Economic,
            Payments,
            showButtonPdf
        },
        computed: {
            ...mapGetters("form", {
                requestForm: "requestForm",
                catalogs: "catalogs",
                general: "general",
                onlyRead: "onlyRead",
                providerActive2: "providerActive"
            }),
            providerActive: {
                get () {
                    return this.providerActive2;
                },
                set (newValue) {
                    return this.$store.dispatch('form/setProviderActive2', newValue, { root: true });
                }
            },


            tableData() {
                return []
            },

        },

        methods: {
            ...mapMutations('form', {
                selectedProvider: "selectedProvider",
                setProviderSelected: "setProviderSelected"
            }),
            filterId(data) {
                data = data.filter(item => item.name);
                return data;
            },
            subTotal(data) {
                let _a = parseFloat(data.monthlyCostWithTaxes);
                let _b = parseFloat(data.carrierExpenses);
                let _c = parseFloat(data.instalmentCosts);
                let _d = parseFloat(data.totalPriceGoodsServices);
                if(_a >= 0 || _b >= 0 || _c >= 0){
                    let suma = _a + _b + _c + _d;
                    if (isNaN(suma) || suma == '' || !suma) return 0;

                    try {
                        return suma.toFixed(2);
                    } catch (err) {
                        return suma;
                    }
                }

            },
            total(data) {
                let _a = parseFloat(data.monthlyCostWithTaxes);
                let _b = parseFloat(data.carrierExpenses);
                let _c = parseFloat(data.instalmentCosts);
                let _e = parseFloat(data.totalPriceGoodsServices);
                let _d = parseFloat(data.anotherExpenses);

                let suma = _a + _b + _c + _d + _e;

                if (isNaN(suma) || suma == '' || !suma) return 0;

                try {
                    return suma.toFixed(2);
                } catch (err) {
                    return suma;
                }
            },

            sumaX(item2,column){

                if(column == 1){
                    let _a = parseFloat(item2.acquisitionPriceGoods);
                    let _b = parseFloat(item2.acquisitionInstallationCosts);
                    let _c = parseFloat(item2.acquisitionTransportationExpenses);
                    let _d = parseFloat(item2.acquisitionOtherExpenses);

                    let suma = _a + _b + _c + _d;

                    if(isNaN(suma) || suma == '' || !suma) return 0;

                    try {
                        return suma.toFixed(2);
                    }catch (err){
                        return suma;
                    }
                }
                if(column == 2){
                    let _a = parseFloat(item2.leasingMonthlyPriceGoods);
                    let _b = parseFloat(item2.leasingMonthlyInstallationCosts);
                    let _c = parseFloat(item2.leasingMonthlyTransportationExpenses);
                    let _d = parseFloat(item2.leasingMonthlyOtherExpenses);

                    let suma = _a + _b + _c + _d;

                    if(isNaN(suma) || suma == '' || !suma) return 0;

                    try {
                        return suma.toFixed(2);
                    }catch (err){
                        return suma;
                    }
                }
                if(column == 3){
                    let _a = parseFloat(item2.leasingMonthsPriceGoods);
                    let _b = parseFloat(item2.leasingMonthsInstallationCosts);
                    let _c = parseFloat(item2.leasingMonthsTransportationExpenses);
                    let _d = parseFloat(item2.leasingMonthsOtherExpenses);

                    let suma = _a + _b + _c + _d;


                    if(isNaN(suma) || suma == '' || !suma) return 0;

                    try {
                        return suma.toFixed(2);
                    }catch (err){
                        return suma;
                    }
                }
                if(column == 4){

                    let _a = parseFloat(item2.leasingAnnualPriceGoods);
                    let _b = parseFloat(item2.leasingAnnualInstallationCosts);
                    let _c = parseFloat(item2.leasingAnnualTransportationExpenses);
                    let _d = parseFloat(item2.leasingAnnualOtherExpenses);

                    let suma = _a + _b + _c + _d;


                    if(isNaN(suma) || suma == '' || !suma) return 0;

                    try {
                        return suma.toFixed(2);
                    }catch (err){
                        return suma;
                    }
                }
            },
        },
        watch: {
            'requestForm.provider_selected': {
                handler(after, before) {
                    this.setProviderSelected(this.requestForm.provider_selected);
                },
                deep: true
            }
        },
    }
</script>

<style scoped>
    .border-red{
        border-right: 5px solid #ab0d48;
    }
</style>
